"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListFilterItem = exports.ProductListFilterItemType = void 0;
var ProductListFilterItemType;
(function (ProductListFilterItemType) {
    ProductListFilterItemType["select"] = "select";
    ProductListFilterItemType["boolean"] = "bool";
    ProductListFilterItemType["range"] = "range";
})(ProductListFilterItemType = exports.ProductListFilterItemType || (exports.ProductListFilterItemType = {}));
class ProductListFilterItem {
    constructor(filterItemData) {
        this.count = filterItemData.count;
        this.type = filterItemData.type;
        this.field = filterItemData.field;
        this.name = filterItemData.name;
        this.values = new Map(filterItemData.values.map((value) => {
            return [value.id, value];
        }));
    }
    disable() {
        this.count = 0;
        this.values = new Map();
    }
    applyFilterItemValueResult(filterItemValueResults) {
        const updatedFilterItemValue = new Set();
        // set new value count in new response
        for (const filterItemValueResult of filterItemValueResults) {
            this.values.set(filterItemValueResult.id, filterItemValueResult);
            updatedFilterItemValue.add(filterItemValueResult.id);
        }
        // reset others value count
        for (const [id, value] of this.values) {
            if (!updatedFilterItemValue.has(id)) {
                this.values.set(id, Object.assign(Object.assign({}, value), { count: 0 }));
            }
        }
    }
}
exports.ProductListFilterItem = ProductListFilterItem;
